module.exports = __webpack_public_path__ + "static/media/logo_green.d40dee2b.svg";